import { Tile as LayerTile } from 'ol/layer';
import { OSM } from 'ol/source';
import { default as LayerRaster } from './RLayerRaster';
/**
 * An OpenStreetMap layer
 *
 * Requires an `RMap` context
 */
export default class ROSM extends LayerRaster {
    constructor(props) {
        super(props);
        this.source = new OSM();
        this.ol = new LayerTile({ source: this.source });
        this.eventSources = [this.ol, this.source];
    }
    refresh(prevProps) {
        super.refresh(prevProps);
        this.ol.setProperties({ label: 'OpenStreetMap' });
    }
}
//# sourceMappingURL=ROSM.js.map